


export class BrowserAppEvaluationToolInfo {

  public version = '2024.3.26.1';

  constructor() {
  }

}
